import React, { useState } from "react";
import { Header, Footer, Page } from "@/components/Shell";
import { CARD_FRONT, CARD_BACK, LOGO_MB } from "@/lib/brand";
import { Phone, Mail, Globe, MapPin } from "lucide-react";

export default function Contact() {
  const [flip, setFlip] = useState(false);
  return (
    <Page tone="ivory">
      <Header variant="ivory" />
      <section className="max-w-6xl mx-auto px-6 md:px-10 pt-20 pb-24 grid md:grid-cols-2 gap-16 items-start" data-testid="contact-page">
        <div>
          <div className="overline mb-6">Pour aller plus loin</div>
          <h1 className="font-display text-[44px] md:text-[54px] leading-tight text-ink">Planifier une rencontre stratégique.</h1>
          <p className="mt-8 text-[18px] text-text-2 leading-relaxed">
            Cette rencontre permet de relire ensemble votre Rapport de Révélation Stratégique™, de clarifier les priorités et d'identifier les décisions les plus importantes à prendre dans les prochains jours.
          </p>

          <div className="mt-12 border border-[color:var(--border-bronze)] bg-ivory-light p-8">
            <div className="flex items-center gap-4 mb-6">
              <img src={LOGO_MB} alt="" className="h-12 object-contain" />
              <div>
                <div className="font-display text-[22px] text-ink">Joanie D. Beaudette</div>
                <div className="text-text-2 text-sm">Fondatrice & Directrice créative</div>
              </div>
            </div>
            <div className="space-y-3 text-ink">
              <a href="tel:+18193147717" className="flex items-center gap-4 hover:text-bronze" data-testid="contact-phone"><Phone className="w-4 h-4 text-bronze" strokeWidth={1.2} /> 819-314-7717</a>
              <a href="mailto:direction@maisonbeaudette.com" className="flex items-center gap-4 hover:text-bronze" data-testid="contact-email"><Mail className="w-4 h-4 text-bronze" strokeWidth={1.2} /> direction@maisonbeaudette.com</a>
              <a href="https://maisonbeaudette.com" target="_blank" rel="noreferrer" className="flex items-center gap-4 hover:text-bronze" data-testid="contact-web"><Globe className="w-4 h-4 text-bronze" strokeWidth={1.2} /> maisonbeaudette.com</a>
              <div className="flex items-center gap-4 text-text-2"><MapPin className="w-4 h-4 text-bronze" strokeWidth={1.2} /> Drummondville, Québec, Canada</div>
            </div>
          </div>

          <p className="mt-10 font-display italic text-[22px] text-bronze leading-snug">« Votre entreprise donne déjà des signaux. Maison Beaudette™ vous aide à les transformer en décisions. »</p>
        </div>

        <div className="relative">
          <button onClick={() => setFlip(!flip)} className="w-full text-left" data-testid="btn-flip-card" aria-label="Retourner la carte de visite">
            <div className="relative aspect-[1.75/1] max-w-xl mx-auto" style={{ perspective: "1400px" }}>
              <div className="absolute inset-0 transition-transform duration-700" style={{ transformStyle: "preserve-3d", transform: flip ? "rotateY(180deg)" : "none" }}>
                <img src={CARD_FRONT} alt="Carte Maison Beaudette recto" className="absolute inset-0 w-full h-full object-contain border border-[color:var(--border-bronze)]" style={{ backfaceVisibility: "hidden" }} />
                <img src={CARD_BACK} alt="Carte Maison Beaudette verso" className="absolute inset-0 w-full h-full object-contain border border-[color:var(--border-bronze)]" style={{ backfaceVisibility: "hidden", transform: "rotateY(180deg)" }} />
              </div>
            </div>
          </button>
          <div className="text-center text-[11px] tracking-[0.28em] uppercase text-text-2 mt-4">Toucher la carte pour la retourner</div>
        </div>
      </section>
      <Footer />
    </Page>
  );
}
